import { Config } from './_config'
import Ajax from './libraries/Ajax'
import * as Cookies from './libraries/Cookies'
import { getDomainWithoutSubdomain } from './libraries/Domain'


let authorization = null

Ajax.setBaseURL( Config.urlAPI )

export function getAuthorization() {
//    return localStorage.getItem('authorization') || sessionStorage.getItem('authorization') || Cookies.getCookie('authorization')
   return Cookies.getCookie('authorization')
}

export function setAuthorization(authorization) {
    Ajax.setHeader('Auth', authorization)
}

export function logon() {
   authorization = getAuthorization()
   // console.log(authorization)
   Ajax.setHeader('Auth', authorization)
   return Ajax.get('sign/user_data')
}

export function logout() {
   return Ajax.get('sign/out')
   .then(() => {
      Cookies.deleteCookie('authorization', getDomainWithoutSubdomain())
   })
}


export function login( data ) {
   return Ajax.post('sign/in', data)
}

export const myInscriptions = () =>
    Ajax.get(`inscription/all_inscriptions`)

export const getNotifications = (startIn = 0) => {
    var limit = 20
    return Ajax.get('notification/list_all/unread/'+startIn+'/'+limit)
}


export const markNotificationToRead = id =>
    Ajax.get('notification/mark_read/'+id)

export const createUserAccount = form =>
    Ajax.post('sign/up', form)

export const forgetPassword = form =>
    Ajax.post('users/forget_password', form)



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/utils.js